/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
import "./layout.scss";

import React from "react";
import PropTypes from "prop-types";
import { navigate } from "gatsby";
import $ from "jquery";
import CookieConsent from "react-cookie-consent";

import {
  isTablet,
  isIPad13,
  isDesktop,
  isMobileOnly,
  withOrientationChange,
} from "react-device-detect";

import SEO from "./seo";

import Header from "./header/header";
import MenuBar from "./menubar/menubar";
import Footer from "./footer/footer";
import CustomFullPage from "./customFullPage/customFullPage";

import { ContextProviderComponent } from "./contextProviderComponent";
import ModalEmbeededComponent from "../components/modalEmbeededComponent/modalEmbeededComponent";
import { Helmet } from "react-helmet";

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundColor: "transparent",
      height: "130px",
      activeSection: 0,
      showForm: "none",
    };
  }

  componentDidMount() {
    this.handleWindowSizeChange();
    this.updateLayoutMode();

    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    if (!!prevProps.fullPage !== !!this.props.fullPage) {
      this.updateLayoutMode();
      window.scrollTo(0, 0);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
    $(window).off("scroll.layoutHeader");
    this.enableRegularScrollMode();
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };
  bindWindowScrollHandler = (isFullPage) => {
    $(window).off("scroll.layoutHeader");

    if (isMobileOnly || isTablet || isIPad13) {
      $(window).on("scroll.layoutHeader", function() {
        var height = $(window).scrollTop();

        if (height > 75) {
          $("header").css({
            background: "#17181D",
          });
        } else {
          $("header").css({
            background: "transparent",
          });
        }
      });
    } else if (isDesktop && !isTablet && !isIPad13 && !isFullPage) {
      $(window).on("scroll.layoutHeader", function() {
        var height = $(window).scrollTop();

        if (height > 75) {
          $("header").css({
            background: "#17181D",
            height: "75px",
          });
        } else {
          $("header").css({
            background: "transparent",
            height: "130px",
          });
        }
      });
    }
  };
  updateLayoutMode = () => {
    const isFullPage = !!this.props.fullPage;

    if (!isFullPage) {
      $("body").addClass("no-padding");
      this.enableRegularScrollMode();
    } else {
      $("body").removeClass("no-padding");
    }

    this.bindWindowScrollHandler(isFullPage);
  };
  enableRegularScrollMode = () => {
    $("html").removeClass("stop-scrolling no-scroll");
    $("body").removeClass("stop-scrolling no-scroll");
    $("html, body")
      .off("wheel")
      .css("overflow", "")
      .css("overflow-y", "auto")
      .css("position", "")
      .css("top", "")
      .css("bottom", "")
      .css("left", "")
      .css("right", "");
  };
  callBackForHubSpotModalShow = (show) => {
    this.setState({ showForm: show });
  };
  callBackForActiveSection = (newVal) => {
    this.setState({ activeSection: newVal });
  };

  onLeave(origin, destination, direction) {
    if (destination.index === 0) {
      $("header").css({
        background: "transparent",
        height: "130px",
      });
    } else {
      $("header").css({
        background: "#17181D",
        height: "75px",
      });
    }
  }

  navigateClickCallback = (index) => {
    switch (index) {
      case 0:
        if (this.props.activeDocMeta.lang == "de-ch") {
          navigate("/warumsmartwealth");
        } else if (this.props.activeDocMeta.lang == "en-gb") {
          navigate("/en-gb/whysmartwealth");
        }
        break;
      case 1:
        navigate("/solutions/");
        break;
      case 2:
        if (this.props.activeDocMeta.lang == "de-ch") {
          navigate("/uberuns");
        } else if (this.props.activeDocMeta.lang == "en-gb") {
          navigate("/en-gb/aboutus");
        }
        break;
      case 3:
        navigate("/insights/");
        break;
      case 4:
        if (this.props.activeDocMeta.lang == "de-ch") {
          navigate("/kontaktiereuns");
        } else if (this.props.activeDocMeta.lang == "en-gb") {
          navigate("/en-gb/contactus");
        }
        break;
      case 5:
        if (this.props.activeDocMeta.lang == "de-ch") {
          navigate("/blog");
        } else if (this.props.activeDocMeta.lang == "en-gb") {
          navigate("/en-gb/blog");
        }
        break;
      case 8:
        if (this.props.activeDocMeta.lang == "de-ch") {
          navigate("/datenschutzbestimmungen");
        } else if (this.props.activeDocMeta.lang == "en-gb") {
          navigate("/en-gb/privacypolicy");
        }
        break;
      case 9:
        if (this.props.activeDocMeta.lang == "de-ch") {
          navigate("/kundeninformation");
        } else if (this.props.activeDocMeta.lang == "en-gb") {
          navigate("/en-gb/customerinformation");
        }
        break;
      case 10:
        if (this.props.activeDocMeta.lang == "de-ch") {
          navigate("/impressum");
        } else if (this.props.activeDocMeta.lang == "en-gb") {
          navigate("/en-gb/imprint");
        }
        break;
      case 11:
        if (this.props.activeDocMeta.lang == "de-ch") {
          navigate("/privatkunden");
        } else if (this.props.activeDocMeta.lang == "en-gb") {
          navigate("/en-gb/privateclient");
        }
        break;
      case 12:
        if (this.props.activeDocMeta.lang == "de-ch") {
          navigate("/institutionellekunden");
        } else if (this.props.activeDocMeta.lang == "en-gb") {
          navigate("/en-gb/institutionalclients");
        }
        break;
      case 13:
        if (this.props.activeDocMeta.lang == "de-ch") {
          navigate("/b2b");
        } else if (this.props.activeDocMeta.lang == "en-gb") {
          navigate("/en-gb/b2b");
        }
        break;
      case 14:
        if (this.props.activeDocMeta.lang == "de-ch") {
          navigate("/brochures");
        } else if (this.props.activeDocMeta.lang == "en-gb") {
          navigate("/en-gb/brochures");
        }
        break;
      case 15:
        if (this.props.activeDocMeta.lang == "de-ch") {
          navigate("/product/3iq");
        } else if (this.props.activeDocMeta.lang == "en-gb") {
          navigate("/en-gb/product/3iq");
        }
        break;
      case 16:
        if (this.props.activeDocMeta.lang == "de-ch") {
          navigate("/product");
        } else if (this.props.activeDocMeta.lang == "en-gb") {
          navigate("/en-gb/product");
        }
        break;
      case 17:
        if (this.props.activeDocMeta.lang == "de-ch") {
          navigate("/product/:isin");
        } else if (this.props.activeDocMeta.lang == "en-gb") {
          navigate("/en-gb/product/:isin");
        }
        break;
      case 18:
        if (this.props.activeDocMeta.lang == "de-ch") {
          navigate("/products");
        } else if (this.props.activeDocMeta.lang == "en-gb") {
          navigate("/en-gb/products");
        }
        break;
      case 99:
        if (this.props.activeDocMeta.lang == "de-ch") {
          navigate("/");
        } else if (this.props.activeDocMeta.lang == "en-gb") {
          navigate("/en-gb");
        }
        break;
      default:
        if (this.props.activeDocMeta.lang == "de-ch") {
          navigate("/");
        } else if (this.props.activeDocMeta.lang == "en-gb") {
          navigate("/en-gb");
        }
        break;
    }
  };

  render() {
    const isFullPageDesktop =
      isDesktop && !isTablet && !isIPad13 && !!this.props.fullPage;

    return (
      <>
        <ContextProviderComponent.Provider
          value={{
            lang: this.props.activeDocMeta.lang,
            translationsDataForForm: this.props.translationsDataForForm,
            state: this.state,
            callBackForActiveSection: this.callBackForActiveSection,
            callBackForHubSpotModalShow: this.callBackForHubSpotModalShow,
            navigateClickCallback: this.navigateClickCallback,
          }}
        >
          <Helmet>
            <html
              lang={this.props.activeDocMeta.lang == "en-gb" ? "en" : "de"}
            />
          </Helmet>
          <SEO {...this.props?.seo} />

          <CookieConsent
            location="bottom"
            buttonText="OK"
            buttonClasses="cookieButton"
            cookieName="smartwealthCookie"
            style={{ background: "#FFFFFF", color: "#17181D" }}
            expires={30}
          >
            {this.props?.body?.data?.cookie_consent &&
              this.props.body.data.cookie_consent.raw.map((paragraph, i) => {
                return <p key={i}>{paragraph.text}</p>;
              })}
          </CookieConsent>

          <ModalEmbeededComponent
            callBackForHubSpotModalShow={this.callBackForHubSpotModalShow}
          />

          {this.props.body && (
            <Header
              callBackForHubSpotModalShow={this.callBackForHubSpotModalShow}
              callBackForActiveSection={this.callBackForActiveSection}
              activeSection={this.state.activeSection}
              headerBackground={this.state.backgroundColor}
              height={this.state.height}
              body={this.props.body}
              activeDocMeta={this.props.activeDocMeta}
              progressBar={this.props.progressBar}
            />
          )}
          {this.props.body && (
            <MenuBar
              headerBackground={this.state.backgroundColor}
              height={this.state.height}
              body={this.props.body}
              activeDocMeta={this.props.activeDocMeta}
            />
          )}

          {isFullPageDesktop ? (
            <CustomFullPage onLeave={this.onLeave.bind(this)}>
              {this.props.children}

              <div className="section">
                <Footer
                  body={this.props.bodyFooter}
                  callBackForActiveSection={this.callBackForActiveSection}
                  activeSection={this.state.activeSection}
                  activeDocMeta={this.props.activeDocMeta}
                />
              </div>
            </CustomFullPage>
          ) : (
            <main>
              {this.props.children}

              <Footer
                body={this.props.bodyFooter}
                callBackForActiveSection={this.callBackForActiveSection}
                activeSection={this.state.activeSection}
                activeDocMeta={this.props.activeDocMeta}
              />
            </main>
          )}
        </ContextProviderComponent.Provider>
      </>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  translationsDataForForm: PropTypes.object,
};

export default withOrientationChange(Layout);
